module.exports = __webpack_public_path__ + "static/media/Soft skills.5af91030.pdf";